import React, { useState } from 'react'
import * as FloatingUi from '@floating-ui/react'
import PropTypes from 'prop-types'

export const BasePopoverPropTypes = {
  anchor: PropTypes.element.isRequired,
  closeOnClick: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  placement: PropTypes.string
}

export type BasePopoverProps = PropTypes.InferProps<typeof BasePopoverPropTypes>

// DO NOT CALL DIRECTLY: Use Popover or PopoverAutoClose instead
export const BasePopover: React.FC<BasePopoverProps> = ({ anchor, children, closeOnClick, placement }) => {
  const [isOpen, setIsOpen] = useState(false)

  const { refs, floatingStyles, context } = FloatingUi.useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [
      FloatingUi.offset(10),
      FloatingUi.flip({ fallbackAxisSideDirection: 'end' }),
      FloatingUi.shift()
    ],
    whileElementsMounted: FloatingUi.autoUpdate,
    placement: placement as FloatingUi.Placement
  })

  const click = FloatingUi.useClick(context)
  const dismiss = FloatingUi.useDismiss(context)
  const role = FloatingUi.useRole(context)

  const { getReferenceProps, getFloatingProps } = FloatingUi.useInteractions([
    click,
    dismiss,
    role
  ])

  const headingId = FloatingUi.useId()

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()}>
        {anchor}
      </div>
      {isOpen && (
        <FloatingUi.FloatingFocusManager context={context} modal={false}>
          <div
            className='floating-ui-popover'
            ref={refs.setFloating}
            style={floatingStyles}
            aria-labelledby={headingId}
            {...getFloatingProps()}
          >
            <div onClick={() => closeOnClick && setIsOpen(false)}>
              {children}
            </div>
          </div>
        </FloatingUi.FloatingFocusManager>
      )}
    </>
  )
}

BasePopover.propTypes = BasePopoverPropTypes
